import {cssTheme} from '@yandex-delivery/blocks/theme'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const orderNumIcon = css`
  block-size: ${spacing(5)};
  border-radius: ${spacing(1.5)};
  inline-size: ${spacing(5)};
`

export const gray = css`
  background-color: ${cssTheme.colors.warmGray['100']};
`

export const black = css`
  background-color: ${cssTheme.colors.deliveryGrey['450']};
`
